import React from 'react'
import './Loader.css'

export default () => <div className='loa-co'><div className='loa-lo'/></div>



// WEBPACK FOOTER //
// ./src/components/Controls/Loader.js